import React from 'react';
import {Step} from '@mui/material';

import {StyledStepLabel, StyledStepper} from './styles';
import {CustomStepperProps} from './types';

function CustomStepper({stepLabels, activeStep, dataTagId}: CustomStepperProps) {
	return (
		<StyledStepper activeStep={activeStep}>
			{stepLabels.map(step => (
				<Step key={step}>
					<StyledStepLabel data-tag-id={dataTagId}>{step}</StyledStepLabel>
				</Step>
			))}
		</StyledStepper>
	);
}

export {CustomStepper};
